import A from '../actions/actionTypes';

const initialState = {
  isActive: false,
  session: null,
  userId: null,
};

export default function (state = initialState, { type, session = initialState }) {
  switch (type) {
    case A.LOG_IN_SUCCESS:
    case A.SIGN_UP_SUCCESS:
      return session;
    case A.LOG_OUT:
    case A.PROFILE_DELETE:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/context.js